<template>
    <!-- カートパーツ（小） -->
    <div id="pt050" class="pt050" v-cloak>
        <div class="itemTitle">
            <img class="itemIcon"/> 
            <!-- カート -->
            <span>{{$t('pt050.labels.cart')}}</span>
        </div>
        <!-- 商品数0の場合 -->
        <div v-if="pt050Init.itemSu == 0" class="cartInfo">
            <!-- 商品は入っていません。 -->
           <span>{{$t('pt050.labels.noProductMsg')}}</span>
        </div>
        <template v-else>
            <div class="cartInfo">
                <div class="cartItem">
                    <span>{{$t('pt050.labels.productPoint')}} : 
                        <span class="cartDanger">{{pt050Init.itemSu}}</span>
                        {{$t('common.labels.point')}}
                    </span>
                </div>
                <div class="col-12">
                    <div class="border-top"></div>
                </div>
                <div class="cartPrice">
                    <span v-if="pt050Init.priceShow != 1">{{$t('common.labels.total')}} : 
                        <span class="cartDanger">{{pt050Init.sumKin}}</span>
                        {{$t('common.labels.jpYen')}}{{tnkKbn}}
                    </span>
                </div>
                <div class="cartBtn">
                    <!-- カートを確認 -->
                    <button @click="doEdit();" type="button" class="btnSubmit">
                        {{$t('pt050.buttons.confirmCart')}}
                    </button>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import axios from "assets/js/request";
import common from "assets/js/common";
import SiteConstants from 'assets/const/SiteConstants.json';
export default {
    name: "PT050ShoppingCartParts",
    props:{
        evtChangeQtyFlg: {
            type: Boolean,
            default: false,
        },
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            tnkKbn:'',
            pt050ReqModel:{},
            pt050Init: {
                itemSu: null,
                siteFlg: null,
                sumKin: null,
                tnkDspKbn: null,
            },
           SiteConstants: SiteConstants,
           site: ""
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.init();
    },
    
    methods: {
        /**
         * call do init to load or reload part
         */
        init: function(){
            var _this = this;
            //Call API to load init
            axios.get(_this.$UrlConstants.ECSITE +_this.$UrlConstants.PT050 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt050Init = response.data;
                if(_this.pt050Init.itemSu != 0){
                    //BtoBの場合
                    if(_this.pt050Init.siteFlg == 1){
                        _this.tnkKbn = "(税抜)";
                    }else{
                        //税込み表示だった場合
                        if(_this.pt050Init.tnkDspKbn == 1){
                            _this.tnkKbn ="(税込)";
                        } else{
                            _this.tnkKbn ="(税抜)";
                        }
                    }
                }
            })
            .catch(function(error) {
                common.errorAPI(error);
            });
        },
        /*
        * goto pg040
        */
        doEdit: function(){
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
        },
    },
    
    watch: {
        /* eslint-disable */
        /**
         * get event change item order
         * @param {any} newVal, 
         * @param {any} oldVal
         */
        evtChangeQtyFlg(newVal, oldVal) {
            this.init();
        }
    },
}
</script>